import { PayloadAction } from "@reduxjs/toolkit";
import { getTimeOffs_timeOffs_timeOffs } from "../../../../__generated/getTimeOffs";
import { LeavesState } from "../leavesSlice";

const leaveAdded = (
  state: LeavesState,
  { payload }: PayloadAction<getTimeOffs_timeOffs_timeOffs>
) => {
  state.timeOffs.push(payload);
};

export default leaveAdded;
